import type { StripePortalDetails } from '@ctct/domain-layer';

import type { TranslationGetter } from '../../../types';

export class StripeOverdueService {
  constructor(private hasOverdue: boolean, private t: TranslationGetter, private stripePortal: StripePortalDetails) {}

  public api() {
    return {};
  }

  public data() {
    return {
      shouldDisplayBanner: () => this.hasOverdue,
      getBannerContent: () => {
        return {
          title: this.t('application-layer.stripe-overdue-banner.title'),
          text: this.t('application-layer.stripe-overdue-banner.text'),
        };
      },
      getStripePortalLinkLabel: () => this.t('application-layer.stripe-overdue-banner.link-label'),
      getPortalUrl: () => this.stripePortal.getPortalUrl(),
    };
  }

  public handlers() {
    return {};
  }
}
